<template>
  <v-btn variant="text" prepend-icon="mdi-book-open-page-variant" @click="openDocs">docs</v-btn>
</template>
<script setup>
function openDocs() {
  window.open('https://ruleshake-website.pages.dev/','_blank')
}
</script>